// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".right-align[data-v-25375419] {\n  float: right;\n}\n.selWidth[data-v-25375419] {\n  width: 250px !important;\n}\n.seachTiele[data-v-25375419] {\n  line-height: 35px;\n}\n.fr[data-v-25375419] {\n  float: right;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
